// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelDisabled-Link_cls1__0XCp7","cls2":"PaymentChannelDisabled-Link_cls2__R0RdH PaymentChannelDisabled-Link_cls1__0XCp7"};